import qs from 'qs'
import getHospitalsQueryObject from '../post/getHospitalsQueryObject'
import getPreviewQueryObject from '../post/getPreviewQueryObject'
import validateQuerySlug from '../post/validateQuerySlug'

export const getDoctors = async ({ queryObj, preview = false }) => {
  // Preview Mode
  queryObj = preview ? getPreviewQueryObject(queryObj) : queryObj
  // Hospitals
  queryObj = getHospitalsQueryObject(queryObj)
  // validate slug
  queryObj = validateQuerySlug(queryObj)

  // Get Posts with fetch
  const baseApiUrl = process.env.NEXT_PUBLIC_BASE_API_URL
  const url = `${baseApiUrl}/v2/doctor-query?${qs.stringify(queryObj)}`
  console.log(`calling ${url}`)
  const res = await fetch(url)
  const data = await res.json()

  if (!data?.success || !data?.posts?.length) {
    return null
  }
  return data
}
